import styled from "styled-components";

import { theme } from "../../styles/theme";

type ButtonProps = {
  color?: string;
  backgroundColor?: string;
  border: boolean;
};

export const ButtonWrapper = styled.button<ButtonProps>`
  border-radius: 20px;
  font-family: ${theme.font.poppins};
  width: 100%;
  justify-content: center;
  align-items: center;
  padding: 20px 15px 20px 15px;
  background-color: ${(props: ButtonProps) => props.backgroundColor};
  color: ${(props: ButtonProps) => props.color};
  border: ${(props: ButtonProps) =>
    props.border ? `1px solid ${theme.colors.blue100}` : "none"};
  line-height: 1;
  padding: 15px 30px;

  &:hover {
    opacity: 0.7;
  }

  &:disabled {
    opacity: 0.4;
  }

  svg {
    margin-right: 5px;
  }
`;
